import React from "react";
import logo from "../assets/img/logo-white.png"; // Adjust path as needed

const Footer = () => {
    return (
        <footer className="footer-1 ptb-60 gradient-bg">
            <div className="container">
                <div className="row">
                    {/* Left Side - Logo & Description */}
                    <div className="col-md-12 col-lg-4 mb-4">
                        <a href="/" className="d-block">
                            <img src={logo} alt="logo" className="img-fluid" />
                        </a>
                        <p className="mt-3">
                            Dynamically re-engineer high standards in functiona with alternative paradigms. Conveniently monetize resource maximizing initiatives.
                        </p>
                        <ul className="list-inline social-list-default mt-2">
                            {[
                                { class: "twitter", icon: "fab fa-twitter", link: "#" },
                                { class: "youtube", icon: "fab fa-youtube", link: "#" },
                                { class: "linkedin", icon: "fab fa-linkedin-in", link: "#" },
                                { class: "dribbble", icon: "fab fa-dribbble", link: "#" },
                            ].map((social, index) => (
                                <li key={index} className="list-inline-item">
                                    <a className={social.class} href={social.link}>
                                        <i className={social.icon}></i>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Right Side - Footer Links */}
                    <div className="col-md-12 col-lg-8">
                        <div className="row">
                            {[
                                {
                                    title: "Resources",
                                    links: ["Help", "Events", "Live sessions", "Open source", "Documentation"],
                                },
                                {
                                    title: "Products",
                                    links: ["Pricing", "Navigation", "AI Studio", "Page Speed", "Performance"],
                                },
                                {
                                    title: "Company",
                                    links: ["About Us", "Careers", "Customers", "Community", "Our Team"],
                                },
                                {
                                    title: "Support",
                                    links: ["FAQ", "Sells", "Contact Support", "Network Status", "Product Services"],
                                },
                            ].map((section, index) => (
                                <div key={index} className="col-sm-6 col-md-3 col-lg-3 mb-4">
                                    <h6 className="font-weight-normal">{section.title}</h6>
                                    <ul>
                                        {section.links.map((link, idx) => (
                                            <li key={idx}>
                                                <a href="#">{link}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
